var exports = {
  "w": "xcc377c0b--426ac5--logo",
  "n": "xcc377c0b--426ac5--link",
};

module.exports = exports;
